module.exports = {"520322001":"海校街道","520322002":"娄山关街道","520322101":"楚米镇","520322102":"新站镇","520322103":"松坎镇","520322104":"高桥镇","520322105":"水坝塘镇","520322106":"官仓镇","520322107":"花秋镇","520322108":"羊磴镇","520322109":"九坝镇","520322110":"大河镇","520322111":"夜郎镇","520322112":"木瓜镇","520322113":"坡渡镇","520322114":"燎原镇","520322115":"狮溪镇","520322116":"茅石镇","520322117":"尧龙山镇","520322118":"风水镇","520322119":"容光镇","520322120":"芭蕉镇","520322203":"小水乡","520322205":"黄莲乡","520322207":"马鬃苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520322.json
// module id = 2599
// module chunks = 0